import { apiClient } from '../utils/api-client'
import type { DashboardData } from '../types/dashboard'

class DashboardService {
  async get(): Promise<DashboardData> {
    const response = await apiClient.get('/api/dashboard', { requireAuth: true })
    return response.json()
  }
}

export const dashboardService = new DashboardService()
